import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import RealTimeAudioComponent from './pages/RealTimeAudioComonent';
import CustomErrorPage from './pages/CustomErrorPage';
import AdminPage from './pages/AdminPage';
import Login from './pages/login';
import PrivateRoute from './components/PrivateRoute';

const AppRoutes: React.FC = () => {
  return (
    <Router>
      <Routes>
        {/* Public Routes */}
        <Route path="/login" element={<Login />} />
        <Route path="/error" element={<CustomErrorPage />} />

        {/* Protected Routes */}
        <Route 
          path="/home" 
          element={
            <PrivateRoute>
              <RealTimeAudioComponent />
            </PrivateRoute>
          } 
        />
        
        <Route 
          path="/admin" 
          element={
            <PrivateRoute>
              <AdminPage />
            </PrivateRoute>
          } 
        />

        {/* Redirect Routes */}
        <Route path="/" element={<Navigate to="/login" replace />} />
        <Route path="*" element={<Navigate to="/login" replace />} />
      </Routes>
    </Router>
  );
};

export default AppRoutes;



